import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { LoginPage } from '@/auth/LoginPage';
import { RegisterPage } from '@/auth/RegisterPage';
import { Layout } from '@/components/Layout';
import { AdminFeedbackPage } from '@/features/admin/AdminFeedbackPage';
import { AdminKackhaufenPage } from '@/features/admin/AdminKackhaufenPage';
import { AdminLayout } from '@/features/admin/AdminLayout';
import { AdminMatchdaysPage } from '@/features/admin/AdminMatchdaysPage';
import { AdminMatchesPage } from '@/features/admin/AdminMatchesPage';
import { AdminMatchResultsPage } from '@/features/admin/AdminMatchResultsPage';
import { AdminPlayersPage } from '@/features/admin/AdminPlayersPage';
import { AdminPredictionsPage } from '@/features/admin/AdminPredictionsPage';
import { AdminPushMessagePage } from '@/features/admin/AdminPushMessagePage';
import { AdminQuestionsPage } from '@/features/admin/AdminQuestionsPage';
import { AdminSyncPage } from '@/features/admin/AdminSyncPage';
import { AdminTeamsPage } from '@/features/admin/AdminTeamsPage';
import { AdminUsersPage } from '@/features/admin/AdminUsersPage';
import { FeedbackPage } from '@/features/feedback/FeedbackPage';
import { MatchdayDetailPage } from '@/features/ergebnistipp/MatchdayDetailPage';
import { MatchdayOverviewPage } from '@/features/ergebnistipp/MatchdayOverviewPage';
import { MatchdayRankingPage } from '@/features/ergebnistipp/MatchdayRankingPage';
import { MatchdaysPage } from '@/features/ergebnistipp/MatchdaysPage';
import { TippuebersichtIndexPage } from '@/features/ergebnistipp/TippuebersichtIndexPage';
import { ProfilePage } from '@/features/profile/ProfilePage';
import { StandingsPage } from '@/features/standings/StandingsPage';
import { AdminRoute } from './AdminRoute';
import { ProtectedRoute } from './ProtectedRoute';

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/matchdays', element: <MatchdaysPage /> },
          { path: '/tippuebersicht', element: <TippuebersichtIndexPage /> },
          { path: '/standings', element: <StandingsPage /> },
          { path: '/profil', element: <ProfilePage /> },
          { path: '/feedback', element: <FeedbackPage /> },
          { path: '/matchdays/:id', element: <MatchdayDetailPage /> },
          { path: '/matchdays/:id/overview', element: <MatchdayOverviewPage /> },
          { path: '/matchdays/:id/ranking', element: <MatchdayRankingPage /> },
        ],
      },
    ],
  },
  {
    element: <AdminRoute />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              { path: '/admin', element: <Navigate to="/admin/users" replace /> },
              { path: '/admin/users', element: <AdminUsersPage /> },
              { path: '/admin/matchdays', element: <AdminMatchdaysPage /> },
              { path: '/admin/matchdays/:id/matches', element: <AdminMatchesPage /> },
              { path: '/admin/matchdays/:id/results', element: <AdminMatchResultsPage /> },
              { path: '/admin/matchdays/:id/questions', element: <AdminQuestionsPage /> },
              { path: '/admin/players', element: <AdminPlayersPage /> },
              { path: '/admin/teams', element: <AdminTeamsPage /> },
              { path: '/admin/predictions', element: <AdminPredictionsPage /> },
              { path: '/admin/kackhaufen', element: <AdminKackhaufenPage /> },
              { path: '/admin/push', element: <AdminPushMessagePage /> },
              { path: '/admin/feedback', element: <AdminFeedbackPage /> },
              { path: '/admin/sync', element: <AdminSyncPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '/', element: <Navigate to="/matchdays" replace /> },
  { path: '*', element: <Navigate to="/matchdays" replace /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
